// extracted by css-extract-rspack-plugin
export default {"label":"EfoFdNdODwohtu_C"};